import CustomNumberInput from "../../../../components/CustomNumberInput";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";

interface Props {
    measureInformationRef: any
    width: string | undefined
    setWidth: React.Dispatch<React.SetStateAction<string | undefined>>
    length: string | undefined
    setLength: React.Dispatch<React.SetStateAction<string | undefined>>
    height: string | undefined
    setHeight: React.Dispatch<React.SetStateAction<string | undefined>>
    volume: string | undefined
    setVolume: React.Dispatch<React.SetStateAction<string | undefined>>
    desi: string | undefined
    setDesi: React.Dispatch<React.SetStateAction<string | undefined>>
    weight: string | undefined
    setWeight: React.Dispatch<React.SetStateAction<string | undefined>>
}

const MeasureInformation = ({
    measureInformationRef,
    width,
    setWidth,
    length,
    setLength,
    height,
    setHeight,
    volume,
    setVolume,
    desi,
    setDesi,
    weight,
    setWeight
}: Props) => {
    return (
        <div className='containerPart' ref={measureInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Ölçü Bilgileri</h4>

                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">En (cm)</label>
                            <CustomNumberInput value={width} setValue={setWidth} />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Boy (cm)</label>
                            <CustomNumberInput value={length} setValue={setLength} />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Yükseklik (cm)</label>
                            <CustomNumberInput value={height} setValue={setHeight} />
                        </div>
                    </div>

                    <div className='row mt-5'>
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Hacim (m<sup>3</sup>)</label>
                            <CustomNumberInput value={volume} setValue={setVolume} />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Desi (m<sup>3</sup>)</label>
                            <CustomNumberInput value={desi} setValue={setDesi} />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Ağırlık (kg)</label>
                            <CustomNumberInput value={weight} setValue={setWeight} />
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default MeasureInformation;